export type FontSizesDesktop = 38 | 32 | 28 | 26 | 24 | 22 | 20 | 16 | 14 | 12;
type FontSizesMobile = 24 | 23 | 22 | 20 | 18 | 17 | 16 | 14 | 12;
/**
 * These were previously classified as light, regular, medium, and semiBold respectively.
 */
export type FontWeights = 300 | 400 | 500 | 600;

/**
 * Mapped type doesn't allow additional properties, hence I used an intersection type:
 * https://stackoverflow.com/questions/67390147/ts1170-error-with-mapped-type-when-a-new-property-is-added
 *
 * We are using the "golden ratio" for line heights. It is set at the top level to be 1.618 of a given font size.
 * @See src/theme/globals/index.ts for the implementation.
 *
 */
export interface TypographyProps {
    sizes: {
        [key in FontSizesDesktop]: string;
    } & {
        mobile: {
            [key in FontSizesMobile]: string;
        };
    };
    weights: {
        [key in FontWeights]: string;
    };
}

export const typography: TypographyProps = {
    sizes: {
        [38]: "38px", // size1
        [32]: "32px", // size2
        [28]: "28px", // size3
        [26]: "26px", // size4
        [24]: "24px", // size5
        [22]: "22px", // size6
        [20]: "20px", // size7
        [16]: "16px", // size8
        [14]: "14px", // size9
        [12]: "12px", // size10
        mobile: {
            [24]: "24px", // size1
            [23]: "23px", // size2
            [22]: "22px", // size3
            [20]: "20px", // size4
            [18]: "18px", // size5
            [17]: "17px", // size6
            [16]: "16px", // size7
            [14]: "14px", // size8
            [12]: "12px" // size9
        }
    },
    weights: {
        [300]: "300",
        [400]: "400",
        [500]: "500",
        [600]: "600"
    }
};
